import styled from 'styled-components'

export interface ColStyles {
  justifyContent?: string
  alignItems?: string
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  gap?: string
  flex?: string
}

export const CustomCol = styled.div<ColStyles>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ gap }) => gap};
  align-items: ${({ alignItems }) => alignItems};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  flex: ${({ flex }) => flex};
`
